import React from 'react';
import { Link } from 'react-router-dom';

// Internal
import Typography from '../components/Typography';
import { sendPasswordResetEmail } from '../services/firebase';

// Antd
import { Form, Input, Button, Space, Divider } from 'antd';

// Icons
import { Mail } from 'react-feather';

// Styles
import styles from './login.module.scss';

function ResetPassword() {
  const onFinish = (values: any) => {
    sendPasswordResetEmail(values.email);
  };

  return (
    <>
      <Space direction="vertical" className={styles.loginPage__container__form__methods}>
        <Typography type="display_md" weight="semibold">
          Forgot password?
        </Typography>

        <Typography type="text_md" color="secondary">
          Lorem ipsum dolor sit amet.
        </Typography>

        <Form onFinish={onFinish}>
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Missing email address' },
              { type: 'email', message: 'Invalid email address' },
            ]}
          >
            <Input prefix={<Mail />} placeholder="Email address" size="large" />
          </Form.Item>

          <Button type="primary" htmlType="submit" size="large">
            Reset password
          </Button>
        </Form>

        <div className={styles.loginPage__container__form__signup__message}>
          <Typography type="text_sm" color="secondary">
            Don't have an account? <Link to="/register">Register</Link> now.
          </Typography>
        </div>
      </Space>
    </>
  );
}
export default ResetPassword;
